/*
 * @Date: 2024-07-19 12:53:31
 * @LastEditors: p彭 9878922+p-pengrulin@user.noreply.gitee.com
 * @LastEditTime: 2024-10-23 04:28:56
 */
/*
 * @Date: 2024-07-19 12:53:31
 * @LastEditors: p彭 9878922+p-pengrulin@user.noreply.gitee.com
 * @LastEditTime: 2024-08-09 14:44:13
 */
import { baseUrl } from "./config";
import { concatQuery } from "./common_method";
import zlFetch from "zl-fetch";
import { sendToLark } from "@/api/publicApi";
import { serialize } from "@/utils/common_method";
import useOpenWallet from "./hooks/useOpenWallet";
import { ElMessage } from "element-plus";
import { useWallet } from "solana-wallets-vue";
import store from "@/store";

let captured = false;
const envMocked = JSON.parse(process.env.VUE_APP_BE_ART_MOCKED);
// fetch
const request = async (config) => {
  //参数解构
  let {
    url,
    method,
    headers = {},
    data = {},
    mocked = envMocked,
    mockedUrl = "",
    showMessage = true,
    suffix = "/api",
  } = config;

  let bUrl = baseUrl;

  if (suffix === "/data") {
    bUrl = "https://beart.one";
  }
  url = mocked ? mockedUrl : bUrl + suffix + url; // 区分mock模式和正常模式
  method = method ? method.toUpperCase() : undefined;

  if (url.includes("/send_message_to_lark")) {
    if (captured) {
      return;
    }
  } else {
    captured = false;
  }

  if (method === "GET") {
    // get请求拼接参数到url
    url = concatQuery(url, data);
    data = undefined;
  }

  headers["Content-Type"] = "application/json";
  try {
    const res = await zlFetch(url, {
      method: method,
      headers,
      body: JSON.stringify(data),
    });
    switch (res.status) {
      case 200: {
        let response = await res.body;
        return Promise.resolve(response);
      }
      default: {
        let errorData = {
          code: res.status,
          message: "接口请求失败",
          date: new Date(),
          path: window.location.href,
          requestApi: res.url,
        };
        sendToLark({
          text: serialize(errorData),
        });
        return Promise.reject(res);
      }
    }
  } catch (error) {
    if (showMessage) {
      ElMessage.error(error.body?.message || "Server error");
    }
    if (error.status === 401) {
      const { open, setRetry } = useOpenWallet();
      const { disconnect } = useWallet();
      await disconnect();
      store.commit("removeUserInfo");
      store.commit("removeToken");
      open();
      setRetry(config);
    } else {
      return Promise.reject(error);
    }
  }
};

export default request;
